<template>
  <div  style="overflow: auto;">
  <h4 class="exerciseTitle" v-if="CelotnaNaloga.text && $options.filters.pickTranslation(CelotnaNaloga.text) !== ''">
    <div class="pull-left">
      <div class="exercise-body" v-html="this.$options.filters.pickTranslation(CelotnaNaloga.text)"></div>
    </div>
    <div class="clearfix"></div>
  </h4>
  </div>

</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'exerciseTitle',
  computed: {
    ...mapGetters({
    })
  },
  props: {
    CelotnaNaloga: Object
  },
  methods: {
  },
  mounted () {
    this.$nextTick(function () {
      window.MathJax.Hub.Queue(['Typeset', window.MathJax.Hub])
    })
  }
}
</script>

<style scoped>
.center {
    margin: auto;
    width: 50%;
    border: 3px solid green;
    padding: 10px;
}

.exercise-body, .exercise-item {
  padding-left: 1ex;
}
.exerciseTitle {
  margin-bottom: 1ex;
}


</style>



// WEBPACK FOOTER //
// ExerciseTitle.vue?4f600208